import { FieldProps, TransportationProps } from "enums/TransportationEnums";
import { FormikContextType } from "formik";
import { transformedDataTransportation } from "../CreateProductFlowInterfaces";

export const handleSaveAsDraftForTransportation = async (formikProps: FormikContextType<transformedDataTransportation>, handleSaveAsDraft: (payload: transformedDataTransportation) => void) => {
  const { validateForm, setFieldTouched } = formikProps;
  const isValidated = await validateForm();
  if (isValidated.ingredients?.length) {
    Array.isArray(isValidated.ingredients) &&
      isValidated.ingredients.forEach((ingredient, index) => {
        if (
          ingredient && typeof ingredient !== 'string' &&
          Array.isArray(ingredient?.multipleOrigin)
        ) {
          ingredient.multipleOrigin.forEach((_, originIndex) => {
            setFieldTouched(
              `${TransportationProps.INGREDIENTS}[${index}].${FieldProps.MULTIPLE_ORIGIN}[${originIndex}].${FieldProps.SUPPLIER_NAME}`,
              true,
              true
            );
            setFieldTouched(
              `${TransportationProps.INGREDIENTS}[${index}].${FieldProps.MULTIPLE_ORIGIN}[${originIndex}].${FieldProps.TEMPERATURE_CONTROL}`,
              true,
              true
            );
          });
        }
      });
  }
  if (isValidated.packageMaterials?.length) {
    Array.isArray(isValidated.packageMaterials) &&
      isValidated.packageMaterials.forEach(
        (packageMaterial, index) => {
          if (
            packageMaterial && typeof packageMaterial !== 'string' &&
            Array.isArray(packageMaterial?.multipleOrigin)
          ) {
            packageMaterial.multipleOrigin.forEach(
              (_, originIndex) => {
                setFieldTouched(
                  `${TransportationProps.PACKAGE_MATERIAL}[${index}].${FieldProps.MULTIPLE_ORIGIN}[${originIndex}].${FieldProps.SUPPLIER_NAME}`,
                  true,
                  true
                );
                setFieldTouched(
                  `${TransportationProps.PACKAGE_MATERIAL}[${index}].${FieldProps.MULTIPLE_ORIGIN}[${originIndex}].${FieldProps.TEMPERATURE_CONTROL}`,
                  true,
                  true
                );
              }
            );
          }
        }
      );
  }
  if (
    Object.keys(isValidated).length === 0
  ) {
    handleSaveAsDraft(formikProps.values);
  }
}